import { useEffect, useState } from 'react';

import { canInvite, isInstanceMember } from './permissions';

interface IsCanInviteLoading {
  loading: true;
  canInvite: undefined;
}

interface IsCanInviteResolved {
  loading: false;
  canInvite: boolean;
}

export const useCanInvite = (
  idCloud: string | undefined,
): IsCanInviteLoading | IsCanInviteResolved => {
  const [canInviteToJira, setCanInviteToJira] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPermission = async (cloudId: string) => {
      setLoading(true);

      if (await isInstanceMember(cloudId)) {
        if (await canInvite(cloudId)) {
          setCanInviteToJira(true);
        }
      }

      setLoading(false);
    };

    if (idCloud) {
      loadPermission(idCloud);
    }
  }, [idCloud]);

  if (!idCloud) {
    return { loading: false, canInvite: false };
  } else if (loading) {
    return { loading, canInvite: undefined };
  }

  return { loading, canInvite: canInviteToJira };
};
